var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMrn = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-17164967788392645",
    d: "M14.4 11.200000000000001 C12.64 11.200000000000001 11.200000000000001 12.64 11.200000000000001 14.4 C11.200000000000001 14.4 11.200000000000001 27.200000000000003 11.200000000000001 27.200000000000003 C11.200000000000001 27.200000000000003 14.4 27.200000000000003 14.4 27.200000000000003 C14.4 27.200000000000003 14.4 14.4 14.4 14.4 C14.4 14.4 17.6 14.4 17.6 14.4 C17.6 14.4 17.6 25.6 17.6 25.6 C17.6 25.6 20.8 25.6 20.8 25.6 C20.8 25.6 20.8 14.4 20.8 14.4 C20.8 14.4 24 14.4 24 14.4 C24 14.4 24 27.200000000000003 24 27.200000000000003 C24 27.200000000000003 27.200000000000003 27.200000000000003 27.200000000000003 27.200000000000003 C27.200000000000003 27.200000000000003 27.200000000000003 14.4 27.200000000000003 14.4 C27.200000000000003 12.64 25.776 11.200000000000001 24 11.200000000000001 C24 11.200000000000001 14.4 11.200000000000001 14.4 11.200000000000001 Z",
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.200000000000001, -11.200000000000001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(145, 158, 171)"
    },
    d: "M14.4 11.200000000000001 C12.64 11.200000000000001 11.200000000000001 12.64 11.200000000000001 14.4 C11.200000000000001 14.4 11.200000000000001 27.200000000000003 11.200000000000001 27.200000000000003 C11.200000000000001 27.200000000000003 14.4 27.200000000000003 14.4 27.200000000000003 C14.4 27.200000000000003 14.4 14.4 14.4 14.4 C14.4 14.4 17.6 14.4 17.6 14.4 C17.6 14.4 17.6 25.6 17.6 25.6 C17.6 25.6 20.8 25.6 20.8 25.6 C20.8 25.6 20.8 14.4 20.8 14.4 C20.8 14.4 24 14.4 24 14.4 C24 14.4 24 27.200000000000003 24 27.200000000000003 C24 27.200000000000003 27.200000000000003 27.200000000000003 27.200000000000003 27.200000000000003 C27.200000000000003 27.200000000000003 27.200000000000003 14.4 27.200000000000003 14.4 C27.200000000000003 12.64 25.776 11.200000000000001 24 11.200000000000001 C24 11.200000000000001 14.4 11.200000000000001 14.4 11.200000000000001 Z",
    vectorEffect: "non-scaling-stroke"
  }))));
};
export default SvgMrn;